import ApiBase from 'apis';
import { companiesAPIUrls } from 'apis/CompanyAPI/companies/companiesApi';
import useLazyResource from 'util/resource/useLazyResource';
import { CompanyOnboardingSuggestions } from 'types/onboarding';

export interface FetchSuggestionsParams {
  founded: string;
  location: string;
  previousSuggestions: CompanyOnboardingSuggestions;
}

export function useCompanyOnboardingAPI(companySlug: string) {
  const api = ApiBase();
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const [fetchSuggestions] = useLazyResource((data: FetchSuggestionsParams) =>
    api.post(companiesAPIUrls.onboarding.getSuggestions(companySlug), { ...data, timezone }),
  );

  return {
    fetchSuggestions,
  };
}
